<template>
  <div class="admin-page">
    <br><br>
    <transition name="toast">
      <Toast v-if="toast" :msg="msg" />
    </transition>
    <ul class="menu-bar">
      <li
        class="menu-icon"
        @click="toggleRecords"
      >
        <ViewListIcon style="width: 25px;" />
        <p>Results</p>
      </li>
      <li
        class="menu-icon"
      >
        <router-link
          class="link"
          :to="{ name: 'Messaging', params: {id: currentUser.state.user.displayName}}"
        >
          <MailIcon style="width: 25px;" />
        <p>Messages</p>
        </router-link>
      </li>
      <li
        class="menu-icon"
        @click="toggleUploadAssignment"
      >
        <PlusIcon style="width: 25px;" />
        <p>Homework</p>
      </li>
    </ul>
    <br>
    <div v-if="showRecords">
      <report-card
      :classLearner="currentUser.state" />
    </div>
    <div v-if="showUploadAssignment" >
      <upload-component
      @uploaded="triggerToast"
      :uploader="currentUser.state"
      />
    </div>
    <div
      v-if="showWelcome"
      class="admin-card card"
    >
      <h3>Welcome Learner</h3>
      <p>This is your virtual class. Do your class work, receive and submit homework, check your grades and engage with your teacher all from here</p>
      <br>
      <class-announcements
      :classNotice="currentUser.state"
      />
    </div>
  </div>
</template>

<script>
import UploadComponent from '@/components/UploadComponent.vue'
import ClassAnnouncements from '@/components/ClassAnnouncements.vue'
import ReportCard from '@/components/ReportCard.vue'
import Toast from '@/components/Toast'
import { MailIcon, ViewListIcon, PlusIcon } from '@heroicons/vue/outline'
import { ref } from '@vue/reactivity'
import { inject } from 'vue'

export default {
  components: { ReportCard, MailIcon, Toast, ViewListIcon, PlusIcon, ClassAnnouncements, UploadComponent },
  setup () {
    const toast = ref(false)
    const showRecords = ref(false)
    const showWelcome = ref(true)
    const showUploadAssignment = ref(false)
    const msg = ref('Download complete')
    const currentUser = inject('currentUser')

    const toggleRecords = () => {
      showRecords.value = !showRecords.value
      showUploadAssignment.value = false
      showWelcome.value = !showRecords.value
    }

    const toggleUploadAssignment = () => {
      showUploadAssignment.value = !showUploadAssignment.value
      showRecords.value = false
      showWelcome.value = !showUploadAssignment.value
    }

    const triggerToast = (edit) => {
      msg.value = 'Uploaded'
      if (edit) {
        msg.value = 'Perfomance Report Edited'
      }
      toast.value = true
      setTimeout(() => {
        toast.value = false
      }, 3000)
    }

    return { toast, triggerToast, toggleRecords, showRecords, toggleUploadAssignment, currentUser, showUploadAssignment, showWelcome }
  }
}
</script>

<style>
.menu-bar {
  display:-webkit-box;
  display:-moz-box;
  display:-ms-flexbox;
  display:-webkit-flex;
  display: flex;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
  position: relative;
  font-weight: 400;
  user-select: none;

  margin: 0.1em 0;
  padding: 0.4em;
  border-radius: 0.25em;
  height: 1.5em;
/* background: hotpink; */
  color: white;
  list-style-type: none;
}
.menu-bar .menu-icon {
  display:-webkit-box;
  display:-moz-box;
  display:-ms-flexbox;
  display:-webkit-flex;
  display: flex;
  border: orangered;
  position: relative;
}
.menu-bar .menu-icon p {
  padding: 5px 0 0 0;
}
.menu-bar .menu-icon a {
  display:-webkit-box;
  display:-moz-box;
  display:-ms-flexbox;
  display:-webkit-flex;
  text-decoration: none;
  color: inherit;
  display: flex;
}
.admin-page {
  height: 100vh;
  max-width: 90vw;
  margin: auto;
}
.admin-card {
  color: white;
  max-width: 600px;
  margin: 0 auto;
  padding: 0.4em;
  border-radius: 0.25em;
  background: #bbb;
}
  /* enter transitions */
  .toast-enter-active {
    animation: wobble 0.5s ease;
  }
  /* leave transitions */
  .toast-leave-to {
    opacity: 0;
    transform: translateY(-60px);
  }
  .toast-leave-active {
    transition: all 0.3s ease;
  }

  @keyframes wobble {
    0% { transform: translateY(-100px); opacity: 0 }
    50% { transform: translateY(0px); opacity: 1 }
    60% { transform: translateX(8px); opacity: 1 }
    70% { transform: translateX(-8px); opacity: 1 }
    80% { transform: translateX(4px); opacity: 1 }
    90% { transform: translateX(-4px); opacity: 1 }
    100% { transform: translateX(0px); opacity: 1 }
  }
</style>
